import React from "react";
import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "../../types/types";
import styles from "./Bundle.module.scss";
import { getProductKey } from "../utils/getProductKey";

export const Bundle: ProductListLayout = ({
  config,
  products,
  heading,
  instanceId,
}) => {
  const [firstProduct, ...otherProducts] = products;

  if (!firstProduct) {
    return null;
  }

  return (
    <div data-product-list-layout="Bundle">
      {heading?.main && <h2>{heading?.main}</h2>}
      {heading?.subHeading && <p>{heading?.subHeading}</p>}
      <div className={styles.carousel}>
        <div className={styles.cardsWrapper}>
          <h3 className={styles.cardsWrapperTitle}>This item</h3>
          <div className={styles.cardWrapper}>
            <ProductCard
              key={getProductKey(firstProduct)}
              product={firstProduct}
              config={config}
              index={0}
              instanceId={instanceId}
            />
          </div>
        </div>
        <div className={styles.joiner}>+</div>
        <div className={styles.cardsWrapper}>
          <h3 className={styles.cardsWrapperTitle}>Bought with</h3>
          <div className={styles.otherProductsWrapper}>
            {otherProducts.map((product, ind) => (
              <React.Fragment key={getProductKey(product)}>
                <div className={styles.cardWrapper}>
                  <ProductCard
                    product={product}
                    config={config}
                    index={ind + 1}
                    instanceId={instanceId}
                  />
                </div>
                {ind + 1 < otherProducts.length && (
                  <div className={styles.joiner}>+</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
